import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function ServiceWarningBanner() {
  const { data: abandonedServices } = useQuery({
    queryKey: ['abandoned-services'],
    queryFn: async () => {
      const { data, error } = await supabase
        .rpc('check_abandoned_services');

      if (error) throw error;
      return data || [];
    },
    refetchInterval: 1000 * 60 * 60, // Refetch every hour
  });

  if (!abandonedServices?.length) return null;

  return (
    <Alert variant="warning" className="mb-6">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Action Required</AlertTitle>
      <AlertDescription>
        {abandonedServices.length === 1 ? (
          <p>
            Your tax return service will be marked as abandoned in {abandonedServices[0].days_remaining} days. 
            Please complete your submission to avoid cancellation.
          </p>
        ) : (
          <p>
            You have {abandonedServices.length} tax return services that will be marked as abandoned soon. 
            Please complete your submissions to avoid cancellation.
          </p>
        )}
      </AlertDescription>
    </Alert>
  );
}